// extracted by mini-css-extract-plugin
export default {"tag":"Experiments_tag__66TFX"};